import PropTypes from 'prop-types';
import Badge from '../../Badge/Badge';

function ShowStatus({
  state = null,
  active = null,
  scanAvailable = null,
  size = 'large',
}) {
  const stateNames = {
    unsent: 'not sent',
    overdue1: 'overdue 1 day',
    overdue2: 'overdue 3 days',
    overdue3: 'overdue 5+ days',
  };

  function getName() {
    if (state) {
      return stateNames[state] || state.replace(/_/g, ' ');
    }
    return active === false ? 'Inactive' : 'Active';
  }

  function getStateColor() {
    switch (state) {
      case 'pending':
      case 'processing':
      case 'unsent':
      case 'on_hold':
      case 'returned':
      case 'inactive':
      case 'ready_to_produce':
      case 'unpaid':
      case 'partially_paid':
      case 'No':
      case 'imported':
        return 'yellow';
      case 'sent':
      case 'complete':
      case 'refunded':
        return 'blue';
      case 'active':
      case 'completed':
      case 'being_manufactured':
      case 'preparing_shipment':
      case 'partially_shipped':
      case 'shipped':
      case 'delivered':
      case 'paid':
      case 'Yes':
      case 'Patient':
        return 'green';
      case 'overdue1':
      case 'overdue2':
      case 'overdue3':
      case 'cancelled':
      case 'needs_attention':
      case 'payment_failed':
      case '1.0 Import':
        return 'red';
      default:
        return 'gray';
    }
  }

  function getColor() {
    if (state) {
      return getStateColor();
    }

    if (active === false) {
      return 'red';
    }

    return 'blue';
  }

  return scanAvailable || scanAvailable === null ? (
    <Badge name={getName()} color={getColor()} withDot={false} size={size} />
  ) : (
    <Badge
      className="m-0 p-0"
      name="Awaiting Scan From Provider"
      color="red"
      withDot={false}
      size={size}
    />
  );
}

ShowStatus.propTypes = {
  state: PropTypes.string,
  active: PropTypes.bool,
  scanAvailable: PropTypes.bool,
  size: PropTypes.oneOf(['small', 'large']),
};

export default ShowStatus;
